import type { LoginFailedResponseHeaders } from 'src/types'
import axios from 'axios'
import dayjs from 'dayjs'
import { Notify } from 'quasar'

export const deno = axios.create({ baseURL: process.env.DENO_URL })
export const api = axios.create({ withCredentials: true, withXSRFToken: true, baseURL: process.env.BASE_URL })

api.interceptors.response.use(res => res, async error => {
  if (axios.isAxiosError<{ message: string, errors: Record<string, string[]> }>(error)) {
    let caption: string | undefined

    if (error.response && [422].includes(error.response.status)) {
      const { 'x-ratelimit-remaining': remaining, 'x-ratelimit-reset': reset } = error.response?.headers as LoginFailedResponseHeaders
      if (reset) caption = `Riprovare ${dayjs(reset, 'X').fromNow()}`
      else if (remaining) caption = `${remaining} tentativi rimasti`
    }

    const message = error.response?.data instanceof Blob
      ? JSON.parse(await error.response?.data.text()).message as string
      : error.response?.data.message

    message && Notify.create({ type: error.response?.status === 422 ? 'warning' : 'negative', message, caption })
  }

  return Promise.reject(error)
})

deno.interceptors.response.use(res => res, async error => {
  if (axios.isAxiosError(error) && error.config?.url !== '/') {
    const message = error.response?.data instanceof Blob
      ? JSON.parse(await error.response?.data.text()) as string
      : error.response?.data

    message && Notify.create({ type: 'negative', message })
  }

  return Promise.reject(error)
})
